<script lang="ts">
import {logoutClick} from "./Authentication.svelte";
</script>

<header class="bg-white shadow">
  <div class="flex max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
    <div class="flex-1">
      <h1 class="text-3xl font-bold leading-tight text-gray-900">
        Servers
      </h1>
    </div>
    <div class="flex-1">
      <span class="absolute inset-y-4 px-4 right-0">
        <button type="submit" class="py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" on:click={logoutClick}>
          Sign Out
        </button>
      </span>
    </div>
  </div>
</header>